import React, { useState, useEffect } from "react";
import {toast} from "react-toastify";
import {Form} from 'react-bootstrap';
import UserService from "services/user.service";

const UpdatesAndPromotions = ({ searchDocId, initialMarketingEmailEnabled,  isReadOnly=false }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isToggling, setIsToggling] = useState(false);

  useEffect(() => {
    setIsEnabled(initialMarketingEmailEnabled || false);
  }, [initialMarketingEmailEnabled]);

  const handleToggle = async () => {
    const newValue = !isEnabled;
    setIsToggling(true);

    try{
      const data = await UserService.marketingEmail(searchDocId, newValue );
      setIsEnabled(data.marketing_email_enabled);
    } catch (error) {
      toast.error("Something went wrong! Please try again later.")
    } finally {
      setIsToggling(false);
    }
  };

  return (
		<div className="profile-info-group">
			<div className= "profile-info-row">
				<div className= "profile-info-label flex-grow-1">
					<p className="mb-0">Updates & promotions - email</p>
					<small className="text-muted fweight-300">Receive newsletter, health updates, and promotional offers from BookDoc</small>
				</div>
				<Form.Check
          type="switch"
          id="marketing-email-preferences-switch"
          label=""
          checked={isEnabled}
          onChange={handleToggle}
          disabled={isReadOnly || isToggling}
          className="ml-4 switch-toggle"
          style={{ transform: 'scale(1.5)'}}/>
			</div>
		</div>
	);
};

export default UpdatesAndPromotions;